module.exports = __webpack_public_path__ + "static/scale-model-of-indian-pueblo-cultural-center-in-albuquerque-new-mexico-d557f02e1465f7eafb79dc35ddd236aa.png";